module.exports = __webpack_public_path__ + "fonts/brandon-grotesque-regular-italic-58a8a456c4724.5b4e03f.woff";